export default __webpack_public_path__ + "static/media/carson-project-3.6a6bedc2.jpg";